import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.TableView extends Backbone.View
  id: 'table'
  name: 'table'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/table"]

  events:
    'click .download-image': 'onClickDownloadImage'

  initialize: (@options = {}) ->
    @response = @options.response
    @response.options ||= {}
    @response.options.table_styles = @options.table_styles || {}
    @linkExists = false

  render: ->
    @$el.html(@template(title: @response.title))
    @_findAccountNameIndex() if @response.options?.account_description && @response.options?.rows?.color
    new Customer.Reports.TableReport(@response, @el).render()
    @id = new Date().toISOString().replace(/[-:.]/g, '')
    linkToImage = $('<a id="download-' + @id + '" class="download-image" style="float:right;cursor:pointer;"><i class="fa fa-download" style="font-size:20px;"></i></a>')
    @$el.append(linkToImage)
    return this

  onClickDownloadImage: (evt) ->
    return if @linkExists
    evt.stopPropagation()
    table = @$el.find('.google-visualization-table')
    tablePlain = table[0]

    # scroll to center the table vertically
    elemTop = table.offset()['top']
    viewportHeight = $(window).height()
    myScroll = elemTop - (viewportHeight / 2);
    $(window).scrollTop(myScroll);

    onrendered = (canvas) =>
      @$el.append(canvas)
      @$el.find('canvas').addClass('canvas').hide()
      @downloadCanvas(evt.currentTarget, 'canvas')
      @$el.find('canvas').remove()
    html2canvas(tablePlain, { onrendered: onrendered })

  downloadCanvas: (link, canvasClass) ->
    filename = $('#' + 'download-' + @id).closest('.container').find('h1')[0].innerHTML
    link.href = @$el.find('.' + canvasClass)[0].toDataURL()
    link.download = filename
    @linkExists = true
    @undelegateEvents()
    setTimeout () =>
      link.click()
      @delegateEvents()
    , 800

  _findAccountNameIndex: =>
    for i in [0..(@response.data.length - 1)] by 1
      if ($.inArray @response.options.account_description, @response.data[i]) > -1
        @response.options['rows'] = { color: { index: i, color: @response.options.rows.color.color } }
